<template>
	<div>
		<Hrader :idShwo="5" @skipCompents="landingClcik"></Hrader>
		<div style="height: 70px"></div>
		<div>
			<img src="../../assets/official-account/mask.png" style="width: 100%; height: 200rpx" />
		</div>
		<div class="rectangle" style="margin-top: -4px">
			<div class="rectangle-with">
				<div class="flex-rectange">
					<div>
						<img src="@/assets/recycling_slices/Vector@2x.png" style="width: 12px; height: 13px" />
					</div>
					<div class="current-recy">当前位置 : 公众号</div>
				</div>
			</div>
		</div>

		<div class="beijing-Card">
			<div style="padding-top: 30px; padding-bottom: 60px">
				<div class="platfor-image">
					<div style="padding-top: 27px; margin-left: 8px">
						京卡收
						<span style="color: #ff3333">公众号使用教程</span>
					</div>
				</div>
			</div>
			<div style="padding-bottom: 70px; display: flex; justify-content: center;">
				<img src="../../assets/official-account/Group 1871@2x.png" style="width: 1178px; height: auto" />
			</div>
		</div>
	</div>
	<Tabr></Tabr>
</template>

<script setup>
import Tabr from '@/components/tabr.vue';
import Hrader from '@/components/header.vue';
</script>

<style lang="scss">
.head-guidance {
	width: 100%;
	height: 70px;
	background: #ffffff;
	border-radius: 0px 0px 0px 0px;
	position: fixed;
	top: 0;
	z-index: 111;
	.head-guidance-flex {
		width: 100%;
		display: flex;
		justify-content: space-between;
		.image {
			width: 106px;
			height: 40px;
			margin-top: 15px;
			margin-left: 160px;
		}
	}
	.head-right {
		display: flex;
		margin-right: 104px;

		.head-right-flex {
			display: flex;
			align-items: center;
			margin-top: 12px;
			margin-left: 36px;

			.home-right {
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 16px;
				color: #333333;
				text-align: left;
				font-style: normal;
				text-transform: none;
				margin-left: 6px;
			}
		}

		.head-right-flex:hover {
			cursor: pointer;
		}

		.head-right-flex1:hover {
			cursor: pointer;
		}

		.head-right-flex1 {
			display: flex;
			align-items: center;
			padding: 11px 16px;
			background: #ff3333;
			border-radius: 74px 74px 74px 74px;
			margin-top: 13px;

			.home-right {
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 16px;
				color: #fff;
				text-align: left;
				font-style: normal;
				text-transform: none;
				margin-left: 6px;
			}
		}
		.frame-flex {
			height: 18px;
			border-right: 1px solid #dddddd;
			margin-top: 26px;
			margin-left: 22px;
			padding-right: 44px;
		}
	}
}

.beijing-Card {
	width: 1280px;
	background: #ffffff;
	border-radius: 10px 10px 10px 10px;
	margin: auto;
	margin-top: 20px;
}
.platfor-image {
	background: url('@/assets/official-account/Group 1785@2x.png') no-repeat;
	background-size: cover;
	width: 268px;
	height: 71px;
	margin: auto;
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 22px;
	color: #333333;
	text-align: left;
	font-style: normal;
	text-transform: none;
}
</style>
